module.exports = function() {
  return new Worker(__webpack_public_path__ + "6221ad2ce85864a0ca72.worker.js");
};